export class AuditTemplateDetail{
    ImageId: string;
    TemplateName: string;

    constructor(ImageId: string, TemplateName: string){
        this.ImageId = ImageId;
        this.TemplateName = TemplateName;

    }
}